
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'


function sortNumber (a, b) {
return b - a
}

export default {
components: {
Group,
XInput,
XHeader,
XButton,
Toast,
Selector,
FormPreview,
Checklist
},
name: 'skill',
data () {
return {
speciality: [],
specList: [],
dellist: []
}
},
methods: {
delSkill () {
this.dellist.sort(sortNumber)
for (var i = 0; i < this.dellist.length; i++) {
this.speciality.splice(this.dellist[i], 1)
this.specList.splice(this.dellist[i], 1)
}
for (var j = 0; j < this.specList.length; j++) {
this.specList[j].key = j
}
this.dellist = []
},
addSkill () {
this.$router.push({name: 'singleSkill'})
},
save () {
this.$router.push({name: 'expertInfo'})
}
},
beforeRouteLeave (to, from, next) {
if (to.name === 'expertInfo' || to.name === 'singleSkill') {
let expertdata = localStorage.getItem('expertdata')
if (expertdata != null) {
var data = JSON.parse(expertdata)
data.speciality = this.speciality
expertdata = JSON.stringify(data)
localStorage.setItem('expertdata', expertdata)
}
} else {
localStorage.removeItem('expertdata')
}
next()
},
created () {
let expertdata = localStorage.getItem('expertdata')
if (expertdata != null) {
var data = JSON.parse(expertdata)
this.speciality = data.speciality
for (var i = 0; i < this.speciality.length; i++) {
var spec = this.speciality[i].superClass + '-' + this.speciality[i].subClass
this.specList.push({
key: i,
value: spec
})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/skill.vue